import { io } from "socket.io-client";

// export const socket = io("https://api.fotfatfat.coms/");
export const socket = io("https://api-fot.kazysport.com");
